import React, { Component } from 'react';
import HeaderTitle from '../../../GeneralComponents/HeaderTitle'
import Loading from '../../../GeneralComponents/LoadingComponen';
import ExportForm from './ExportForm'
import ImportForm from './ImportForm'
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

class Index extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            activeTab: '1',
            tenants: [],
            tenantsLoaded: false,
        }
    }

    componentDidMount() {
        this.loadTenants();
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab });
        }
    }

    loadTenants = () => {
        fetch(`/formatos/module_transfers/tenants`, {
            method: 'GET',
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                tenants: data.tenants || [],
                tenantsLoaded: true
            });
        });
    }

    formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('es-CO', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    getStatusBadge = (status) => {
        const badges = {
            'completed': 'badge badge-success',
            'failed': 'badge badge-danger',
            'pending': 'badge badge-warning',
            'processing': 'badge badge-info'
        };
        return badges[status] || 'badge badge-secondary';
    }

    getStatusText = (status) => {
        const texts = {
            'completed': 'Completado',
            'failed': 'Fallido',
            'pending': 'Pendiente',
            'processing': 'Procesando'
        };
        return texts[status] || status;
    }

    handleDeleteHistory = (item) => {
        if (confirm(`¿Eliminar este registro de ${item.type === 'export' ? 'exportacion' : 'importacion'}?`)) {
            const url = `/formatos/module_transfers/delete_history/${item.type}/${item.id}`;

            fetch(url, {
                method: 'DELETE',
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    alert("Eliminado correctamente");
                    if (this.props.loadHistory) {
                        this.props.loadHistory();
                    }
                } else {
                    alert("Error: " + (data.error || 'Error al eliminar'));
                }
            })
            .catch(error => {
                alert("Error de conexion");
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <HeaderTitle
                    title={"Transferencia de Modulos"}
                    subTitle={"Exportar e importar modulos entre empresas"}
                    titleNew={""}
                    titleFilter={""}
                    icon="fas fa-exchange-alt"
                    onClickNew={() => {}}
                    showNew={false}
                    showFilter={false}
                />

                <div className="content main-card mb-3 card">
                    <div className="card-body">
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={this.state.activeTab === '1' ? 'active' : ''}
                                    onClick={() => { this.toggle('1'); }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <i className="fas fa-download mr-2"></i>
                                    Exportar Modulo
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={this.state.activeTab === '2' ? 'active' : ''}
                                    onClick={() => { this.toggle('2'); }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <i className="fas fa-upload mr-2"></i>
                                    Importar Modulo
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={this.state.activeTab === '3' ? 'active' : ''}
                                    onClick={() => { this.toggle('3'); }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <i className="fas fa-history mr-2"></i>
                                    Historial
                                </NavLink>
                            </NavItem>
                        </Nav>

                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="1">
                                <div className="pt-4">
                                    {this.state.tenantsLoaded ? (
                                        <ExportForm
                                            tenants={this.state.tenants}
                                            loadHistory={this.props.loadHistory}
                                        />
                                    ) : (
                                        <Loading />
                                    )}
                                </div>
                            </TabPane>

                            <TabPane tabId="2">
                                <div className="pt-4">
                                    {this.state.tenantsLoaded ? (
                                        <ImportForm
                                            tenants={this.state.tenants}
                                            loadHistory={this.props.loadHistory}
                                        />
                                    ) : (
                                        <Loading />
                                    )}
                                </div>
                            </TabPane>

                            <TabPane tabId="3">
                                <div className="pt-4">
                                    {this.props.isLoaded ? (
                                        <Loading />
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-hover table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Tipo</th>
                                                        <th>Empresa</th>
                                                        <th>Modulo</th>
                                                        <th>Archivo</th>
                                                        <th>Usuario</th>
                                                        <th>Estado</th>
                                                        <th>Fecha</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.props.history.length > 0 ? (
                                                        this.props.history.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <span className={item.type === 'export' ? 'badge badge-primary' : 'badge badge-info'}>
                                                                        {item.type === 'export' ? 'Exportacion' : 'Importacion'}
                                                                    </span>
                                                                </td>
                                                                <td>{item.tenant_name}</td>
                                                                <td>{item.category_name || '-'}</td>
                                                                <td>{item.filename}</td>
                                                                <td>{item.user}</td>
                                                                <td>
                                                                    <span className={this.getStatusBadge(item.status)}>
                                                                        {this.getStatusText(item.status)}
                                                                    </span>
                                                                </td>
                                                                <td>{this.formatDate(item.created_at)}</td>
                                                                <td>
                                                                    <button
                                                                        className="btn btn-sm btn-danger"
                                                                        onClick={() => this.handleDeleteHistory(item)}
                                                                        title="Eliminar"
                                                                    >
                                                                        <i className="fas fa-trash"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="8" className="text-center text-muted">
                                                                No hay registros de transferencias
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </TabPane>
                        </TabContent>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Index;
